<template  v-if="modelValue">
    <div class="general-info">
        <h4 
            :class="{
                'marker-new': dataAddresMarker && modelValue.addressType?.title === 'Адрес места жительства'
            }"
            class="mb-0 pl-3 solid">
            {{ modelValue.addressType?.title }}
        </h4>
        <div v-if="modelValue.addressType.name === 'PermanentRegistration' || modelValue.addressType.name === 'TemporaryRegistration'" class="same-addr-wrapper mt-4">
            <side-checkbox-component v-model="sameAddress" :id="modelValue.addressType.name"
                @change="copyRegAddress(modelValue.addressType.name)">Совпадает с адресом места
                жительства
            </side-checkbox-component>
        </div>
        <div class="d-flex align-items-start flex-wrap" v-if="modelValue.addressType.name === 'TemporaryRegistration'">
            <div class="form-group me-3 d-flex flex-column">
                <label class="control-label">Сроки регистрации с</label>
                <date-component v-model="value.dateRegisterFrom" scopeName="addresses" />
            </div>
            <div class="form-group d-flex flex-column">
                <label class="control-label">по</label>
                <date-component v-model="value.dateRegisterTo" scopeName="addresses" />
                <div class="invalid-msg" v-if="v$.value.dateRegisterTo.$error && v$.value.dateRegisterTo.notBeforeFrom.$invalid">Дата должна быть не меньше даты c</div>
            </div>
        </div>
        <div v-if="!((modelValue.addressType.name === 'PermanentRegistration' || modelValue.addressType.name === 'TemporaryRegistration') && sameAddress)">
            <div class="row d-flex flex-column flex-md-row">
                <div class="form-group col col-lg-2" :class="{ required: isRequired }">
                    <component-input label="Государство" :select2Options="stateList" v-model="value.stateId"
                     v-on:select2OnSelect="reloadRegionList" 
                    type="select2" :select2Settings="select2settings" :required="true"
                    :disabled="modelValue.addressType.name === 'Residence'"/>
                </div>
                <div class="col col-lg-1 form-group" v-if="value.stateId == 1">
                    <component-input label="Индекс" v-model="value.postalCode" class="form-control" 
                    scopeName="addresses" type="index" />
                </div>
                <div class="form-group col col-lg-4"  v-if="value.stateId == 1"
                    :class="{ required: isRequired }">
                    <component-input label="Субъект РФ" :select2Options="regionList" v-model="value.regionId" 
                    v-on:select2OnSelect="reloadDistrictList"  
                    type="select2" :select2Settings="select2settings" :required="isRequired"
                    :disabled="modelValue.addressType.name === 'Residence'"/>                    
                </div>
                <div class="form-group col col-lg-5" v-if="value.regionId == regionNizhnyNovgorodId && value.stateId == 1"
                    :class="{ required: isRequired }">
                    <component-input label="Район" :select2Options="districtList" v-model="value.districtId" scopeName="addresses"
                    type="select2" :select2Settings="select2settings" :required="isRequired"/>                      
                </div>   
                <div class="form-group col col-lg-5" v-if="value.regionId != regionNizhnyNovgorodId && value.stateId == 1">
                    <component-input label="Район" v-model="value.regionStr" class="form-control" maxLength="128" 
                    scopeName="addresses"/>
                </div>                                
            </div>
            <div class="row d-flex flex-column flex-md-row"  v-if="value.stateId != 1">
                <div class="form-group col col-lg-12" 
                    :class="{ required: isRequired }">
                    <component-input label="Полный адрес" v-model="value.addressStr" class="form-control" maxLength="256" 
                    scopeName="addresses" :required="isRequired"/>
                </div>
            </div>            
            <div class="row d-flex flex-column flex-md-row" v-if="value.stateId == 1">
                <div class="form-group col col-lg-6"
                    :class="{ required: isRequired }">
                    <label class='control-label'>Город / Нас. пункт</label>
                    <autocomplete-input
                            v-model="value.city"
                            :id="value.addressType.name+'_city'"
                            url="/api/fias/search" placeholder="Введите название города"
                            v-on:select="cityChanged"
                    />
<!--                    <input type="text" v-model="value.city" class="form-control">-->
                    <div class="invalid-msg" v-if="v$.value.city.$error">
                        <template v-if="v$.value.city.maxLength.$invalid">Максимальная длина поля
                            {{ v$.value.city.maxLength.$params.max }} символов.
                        </template>
                        <template v-else>Поле обязательно для заполнения</template>
                    </div>
                </div>
                <div class="form-group col col-lg-6"
                    :class="{ required: isRequired }">
                    <component-input v-model="value.street" class="form-control" label="Улица" maxlength="100" 
                    :required="isRequired" scopeName="addresses" placeholder="Введите название улицы"/>                     
                </div>                    
            </div>
            <div class="row d-flex flex-md-row" v-if="value.stateId == 1">
                <div class="col-2 col-lg-3"
                    :class="'form-group' + (modelValue.addressType.name === 'Residence' ? ' required' : '')">
                    <component-input v-model="value.house" class="form-control" label="Дом" maxlength="10" 
                    :required="modelValue.addressType.name === 'Residence'" scopeName="addresses" placeholder="Введите номер дома"/>
                </div>                    
                <div v-if="modelValue.addressType.name !== 'WorkPlace'" class="form-group col-2">
                    <component-input v-model="value.housing" class="form-control" label="Корпус" maxlength="10" 
                    scopeName="addresses" placeholder="Введите корпус"/>   
                </div>
                <div v-if="modelValue.addressType.name !== 'WorkPlace'" class="form-group col-2">
                    <component-input v-model="value.building" class="form-control" label="Строение" maxlength="10" 
                    scopeName="addresses" placeholder="Введите строение"/>                       
                </div>
                <div v-if="modelValue.addressType.name !== 'WorkPlace'" class="form-group col-2">
                    <component-input v-model="value.room" class="form-control" label="Квартира" maxlength="10" 
                    scopeName="addresses" placeholder="Введите номер квартиры"/>  
                </div>
                <div v-if="modelValue.addressType.name !== 'WorkPlace'" class="form-group col-2">
                    <component-input v-model="value.floor" class="form-control" label="Этаж" maxlength="10" 
                    scopeName="addresses" placeholder="Введите этаж"/>  
                </div>
            </div>
            <div v-if="(modelValue?.addressTypeId == '1' || modelValue?.addressTypeId == '3')" class="row">
                <div class="form-group col-5 col-md-3">
                    <component-input
                        label="Телефон"
                        type="phone"
                        v-model="value.phone"
                        scopeName="addresses"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Constants from "../../../common/constants";
import Utils from "../../../common/utils";
import SideCheckboxComponent from "../../../common/ui/sideCheckboxComponent";
import {useVuelidate} from '@vuelidate/core'
import {maxLength, requiredIf} from "@vuelidate/validators";
import ComponentInput from "@/common/components/ComponentInput";
import AutocompleteInput from "../../../common/components/AutocompleteInput";
import DateComponent from "@/common/components/DateComponent";

export default {
    name: "PersonAddress",
    components: {AutocompleteInput, ComponentInput, SideCheckboxComponent, DateComponent},
    props: {
        modelValue: Object,
        readonly: {
            type: Boolean,
            default: false
        },
        nn: Object,
        dataAddresMarker: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue'],

    data() {
        return {
            stateList: [
                {id: 0, text: Constants.emptySelectOptionText, selected: true},
            ],
            regionList: [
                {id: 0, text: Constants.emptySelectOptionText, selected: true},
            ],
            districtList: [
                {id: 0, text: Constants.emptySelectOptionText, selected: true},
            ],
            sameAddress: false,
            select2Settings: Constants.select2Settings,
            regionNizhnyNovgorodId: Constants.regionNizhnyNovgorodId
        };
    },
    created() {
        this.loadDictionaries();
    },
    watch: {
            nn: function (newValue) {
                console.log(newValue);
                if(this.modelValue.addressType.name === 'PermanentRegistration' || this.modelValue.addressType.name === 'TemporaryRegistration') {
                    //перезагружаем справочники
                    Utils.loadSelectOptions("region", this.regionList, {stateId: this.modelValue.stateId}, true);
                    Utils.loadSelectOptions("district", this.districtList, {regionId: this.modelValue.regionId}, true);
                }
            },
    },
    methods: {
        loadDictionaries() {
            Utils.loadSelectOptions("state", this.stateList);
            if(this.modelValue) {
                Utils.loadSelectOptions("region", this.regionList, {stateId: this.modelValue.stateId}, true);
                Utils.loadSelectOptions("district", this.districtList, {regionId: this.modelValue.regionId}, true);
            }
        },
        reloadRegionList(data) {
            this.value.regionId = '0';
            this.value.districtId = '0';
            Utils.loadSelectOptions("region", this.regionList, {stateId: data.value.id}, true);
        },
        reloadDistrictList(data) {
            this.value.districtId = '0';
            Utils.loadSelectOptions("district", this.districtList, {regionId: data.value.id}, true);
        },
        copyRegAddress(type) {
            if (this.sameAddress) {
                this.$emit('copyaddress', this.modelValue, type);
            }
        },
      cityChanged() {
          if (!this.value.city) {
            return;
          }
          let addr = this.value.city.split(',');
          if (addr.length > 1) {
            const street = addr.pop().trim();
            if (!street) {
              return;
            }
            const region = this.regionList.find((x) => addr[0].indexOf(x.text) > -1);
            let regionId, regionName;
            if (region) {
              regionId = region.id;
              regionName = region.text;
              addr.splice(0, 1);
            }
            const city = addr.join(', ').trim();
            let html = [];
            html.push('Использовать следующий адрес:');
            if (regionName) {
              html.push(`<strong>Субъект государства:</strong> ${regionName}`);
            }
            html.push(`<strong>Город / Нас. пункт:</strong> ${city}`);
            html.push(`<strong>Улица:</strong> ${street}?`);
            const confirmOptions = {
              title: 'Выбор адреса',
              html: html.join('<br/>'),
              confirmButtonText: 'Да',
              cancelButtonText: 'Нет',
              showCancelButton: true,
              icon: 'question'
            };
            Constants.alert.fire(confirmOptions).then((res) => {
              if (res.isConfirmed) {
                if (regionId) {
                  this.value.regionId = regionId;
                }
                this.value.city = city;
                this.value.street = street;
              }
            });
          }
      }
    },
    computed: {
        value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        },
        isRequired() {
            return ['Residence', 'PermanentRegistration'].includes(
                this.value.addressType.name
            );
        },
    },
    setup: () => ({v$: useVuelidate()}),
    validations() {
        return {
            value: {
                city: {
                    maxLength: maxLength(100),
                    required: requiredIf(this.isRequired && this.modelValue.stateId == 1)
                },
                dateRegisterTo: {
                    notBeforeFrom: (value) => {
                        if (!value) return true;
                        if (!this.modelValue.dateRegisterFrom) return true;
                        return new Date(value) >= new Date(this.modelValue.dateRegisterFrom);
                    }
                },
            }
        };
    }
}
</script>

<style lang="scss" scoped>
@import '/src/modules/ras/views/index';

.same-addr-wrapper {
    margin-left: -32px;
    margin-top: 8px;
}


.select2::v-deep {
    .select2-container {
        width: 100% !important;
        max-width: 100% !important;
    }

    .select2-container--default .select2-selection--single {
        height: calc(2.25rem + 2px) !important;
    }

    .select2-container--default .select2-selection--single .select2-selection__arrow {
        top: 7px !important;
    }
}

.solid {
    background-color:#F5F5FA;//rgba(171,171,179, 0.1);
    line-height: 3rem;
    letter-spacing: 0.5px;
}
</style>